/**
 * Search results — type tabs filter the server-rendered rows by kind and
 * keep the count + empty state in sync. (The query itself re-searches
 * server-side on submit.)
 */
export function initSearch() {
	const tabs = document.getElementById('chada-search-tabs');
	const results = document.getElementById('chada-search-results');
	if (!tabs || !results) return;

	const rows = Array.from(results.querySelectorAll('.res'));
	const empty = document.getElementById('chada-search-empty');

	const apply = (tab) => {
		let shown = 0;
		rows.forEach((row) => {
			const match = tab === 'all' || row.dataset.type === tab;
			row.style.display = match ? '' : 'none';
			if (match) shown++;
		});
		if (empty) empty.style.display = shown === 0 ? 'block' : 'none';
	};

	tabs.addEventListener('click', (e) => {
		const tab = e.target.closest('.s-tab');
		if (!tab) return;
		tabs.querySelectorAll('.s-tab').forEach((t) => t.classList.remove('active'));
		tab.classList.add('active');
		apply(tab.dataset.tab);
	});
}
